"use strict";

/**
 * @module TopicUpdate
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateStreamBuilderImpl = void 0;
var require_non_null_1 = require("./../util/require-non-null");
var update_constraint_1 = require("./update-constraint");
var DEFAULT_SPECIFICATION = null;
var DEFAULT_CONSTRAINT = new update_constraint_1.Unconstrained();
/**
 * Implementation of {@link UpdateStreamBuilder}.
 */
var UpdateStreamBuilderImpl = /** @class */function () {
  /**
   * Constructor.
   */
  function UpdateStreamBuilderImpl(context, updateStreamFactory) {
    /**
     * The optional topic specification for the update stream
     */
    this.topicSpecification = DEFAULT_SPECIFICATION;
    /**
     * The optional topic constraint for the update stream
     */
    this.topicConstraint = DEFAULT_CONSTRAINT;
    this.context = context;
    this.updateStreamFactory = updateStreamFactory;
  }
  /**
   * Check if the supplied topic type is supported
   *
   * @param type  the topic type or specification
   * @return      `true` if the type is one of the supported topic types
   */
  UpdateStreamBuilderImpl.prototype.isSupportedTopicType = function (type) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var TopicTypeEnum = this.context.TopicTypeEnum;
    return Object.keys(TopicTypeEnum).some(function (t) {
      return TopicTypeEnum[t] === type;
    });
  };
  /**
   * @inheritdoc
   */
  UpdateStreamBuilderImpl.prototype.specification = function (topicSpecification) {
    if (topicSpecification === null || topicSpecification === undefined) {
      this.topicSpecification = null;
    } else if (this.isSupportedTopicType(topicSpecification)) {
      this.topicSpecification = new this.context.TopicSpecification(topicSpecification);
    } else {
      this.topicSpecification = topicSpecification;
    }
    return this;
  };
  /**
   * @inheritdoc
   */
  UpdateStreamBuilderImpl.prototype.constraint = function (updateConstraint) {
    this.topicConstraint = updateConstraint === null || updateConstraint === undefined ? DEFAULT_CONSTRAINT : updateConstraint;
    return this;
  };
  /**
   * @inheritdoc
   */
  UpdateStreamBuilderImpl.prototype.reset = function () {
    this.topicSpecification = DEFAULT_SPECIFICATION;
    this.topicConstraint = DEFAULT_CONSTRAINT;
    return this;
  };
  /**
   * @inheritdoc
   */
  UpdateStreamBuilderImpl.prototype.build = function (path, dataType) {
    require_non_null_1.requireNonNull(path, 'path');
    require_non_null_1.requireNonNull(dataType, 'dataType');
    if (this.topicSpecification !== null) {
      return this.updateStreamFactory.createUpdateStreamThatAddsTopic(path, this.topicSpecification, dataType, this.topicConstraint);
    } else {
      return this.updateStreamFactory.createUpdateStream(path, dataType, this.topicConstraint);
    }
  };
  return UpdateStreamBuilderImpl;
}();
exports.UpdateStreamBuilderImpl = UpdateStreamBuilderImpl;